import gql from 'graphql-tag';

export const REGISTER_PROJECT_PAGE_FRAGMENT = gql`
  fragment registerProjectPage on RegisterProjectPageType {
    createdAt
    updatedAt
    id
    title
    text
  }
`;
